import type { TranslationTree } from '../../types';

export const auth: TranslationTree = {
  auth: {
    loading: 'Loading…',
    hero: {
      badge: 'ToolLife login',
      title: 'Tool lifecycle management',
      description:
        'Manage milling tool traceability, analytics, and tool lifecycle monitoring from a single platform.',
      tagline: 'Traceability · Analytics · Tool monitoring',
      promises: {
        traceability: {
          title: 'Traceability',
          description:
            'Log tool operations by QR scan or manual entry and view the resulting history per tool.',
        },
        machineControl: {
          title: 'Analytics',
          description:
            'View KPI charts and compare multiple tool references on the analytics dashboard.',
        },
        security: {
          title: 'Secure access',
          description: 'Encrypted connections and role-based access control.',
        },
      },
    },
    login: {
      badge: 'Secure portal',
      title: 'Sign in to ToolLife',
      description: 'Enter your credentials to access the platform.',
      fields: {
        email: {
          label: 'Email address',
          placeholder: 'Email',
        },
        password: {
          label: 'Password',
          placeholder: '••••••••',
          show: 'Show password',
          hide: 'Hide password',
        },
        remember: 'Remember me on this device',
      },
      button: {
        idle: 'Sign in',
        submitting: 'Signing in…',
      },
      errors: {
        unexpected: 'An unexpected error occurred.',
      },
      footer: {
        notice: 'Only sign in from a trusted device.',
      },
    },
    highlights: {
      security: {
        title: 'Security first',
        description: 'Encrypted authentication and granular role management.',
      },
      liveMonitoring: {
        title: 'Tool view',
        description:
          "Browse the tool list, check each tool's RUL status indicator, and view its full trace history.",
      },
      automation: {
        title: 'Traceability entry',
        description:
          'Log an operation via QR scan or manual form, capturing machine, material, and tool holder.',
      },
      experience: {
        title: 'Multilingual UI',
        description:
          'The interface is available in English, French, and German, selectable from the login screen.',
      },
    },
    support: {
      title: 'Support',
      description: 'Contact us for installation, onboarding, or security questions.',
      email: 'ing.toollife@he-arc.ch',
      instructions: 'Reply to this email and we will get back to you.',
    },
    password: {
      requirements: {
        hint: 'At least 8 characters, including an uppercase letter, a lowercase letter, and a digit.',
      },
    },
  },
};
